import type { SVGProps } from "react";
const Svg75PercentSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#75_Percent_SVG_svg__a)">
      <path stroke="#103976" d="M5 25.5h23" />
      <path fill="#CFD7E4" stroke="#103976" d="M4.5 25.5h24v16h-24z" />
      <path stroke="#C0C0C1" d="M16.5 6v-18" />
      <path fill="#D2D2D2" fillOpacity={0.84} d="M4 26h25v16H4z" />
      <path fill="#CFD7E4" stroke="#103976" d="M4.5 6.5h24v19h-24z" />
      <circle cx={16.5} cy={23.5} r={6.5} fill="#D2D2D2" />
      <circle cx={16.5} cy={23.5} r={6} stroke="#ADAFB0" strokeOpacity={0.5} />
    </g>
    <defs>
      <clipPath id="75_Percent_SVG_svg__a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Svg75PercentSvg;
